export default __webpack_public_path__ + "/assets/header_02.png";